import React, { FunctionComponent, Suspense } from 'react'
import useLocalStorageValue from '../Options/hooks/useLocalStroageValue'

const MSATsLayer = React.lazy(() => import('./MSATsLayer/MSATsLayer'))
const EMSStationsLayer = React.lazy(() => import('./EMSStationsLayer/EMSStationsLayer'))
const TrafficLayer = React.lazy(() => import('./TrafficLayer/TrafficLayer'))
const MapTypeLayer = React.lazy(() => import('./MapTypeLayer/MapTypeLayer'))
const CountiesLayer = React.lazy(() => import('./CountyLayers/CountyLayers'))
const DriveTexasLayer = React.lazy(() => import('./DriveTexasLayer/DriveTexasLayer'))
const GeofenceLayer = React.lazy(() => import('./GeofenceLayer/GeofenceLayer'))

interface IProps {
  userId: number
}

const Layers: FunctionComponent<any> = (props: IProps) => {
  const { userId } = props

  const msats = useLocalStorageValue('assettrak_msats')
  const emsStations = useLocalStorageValue('assettrak_ems_stations')
  const traffic = useLocalStorageValue('assettrak_traffic')
  const driveTexas = useLocalStorageValue('assettrak_drive_texas')

  return (
    <Suspense fallback={null}>
      {msats ? <MSATsLayer /> : null}
      {emsStations ? <EMSStationsLayer /> : null}
      {traffic ? <TrafficLayer /> : null}
      <MapTypeLayer />
      <CountiesLayer />
      {driveTexas ? <DriveTexasLayer /> : null}
      {userId ? <GeofenceLayer userId={userId} /> : null}
    </Suspense>
  )
}

export default Layers
